import React from 'react';
import { useStyles } from '../styles';
import Checkbox from "@mui/material/Checkbox";
import {Box,CardMedia} from  "@material-ui/core";
import CurrencySymbol from './CurrencySymbol';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

export default function AddOns(props) {
  const styles = useStyles();
  let selectedCount=0;
  let allowedMaxCount = props.cat.maxAddOnAllowed;
  let minCount = props.cat.minAddOnAllowed;
  
        return   <div className={props.customizeInWizard?styles.center:styles.centerAutoFit} > 
        <h4  style={{textAlign:"center",margin:"2px", fontSize:"1.1rem"}}><i style={{color:'#fff'}}>{props.t({ id: "choose_your" })}</i>{" "}{props.cat.name}</h4>
          <div style={{fontWeight:"bold",fontSize:"0.75em",textAlign:"center"}}>{'(Min: '+minCount+ ', Max: '+ allowedMaxCount+')'}</div>
                  <div className={props.customizeInWizard?'add_on_container container_ad':"add_on_container"}>
                    {props.items.filter(itm=> itm.category == props.cat.id).map(itm => 
                    {
                      let isSelected=props.orderItem['sub_pro']['addons'].filter(ao => ao.id == itm.id).length;
                      if(isSelected) {selectedCount= selectedCount+1;}
                     
                      return <div style={{ position: "relative", border: isSelected > 0 ? "2px solid #23B909" : "1px solid transparent" }} className='add_on_item' id={itm.id}
                    onClick={()=>(allowedMaxCount > selectedCount? props.onSelectionChange(itm):props.onSelectionChange(itm,true))}>
                      {isSelected > 0 && (
                        <CheckCircleIcon 
                          style={{
                            position: "absolute",
                            top: "-8px",
                            left: "-8px",
                            color: "#23B909",
                            backgroundColor: "#fff",
                            borderRadius: "50%",
                            fontSize: "24px",
                            zIndex: 10
                          }}
                        />
                      )}
                      <CardMedia
                                component="img"
                                image={itm.image}
                                className={styles.mediaSmall}
                                onError={props.imageOnErrorHandler}
                              />
                    <div style={{
                      margin: "4px",
                      fontSize: "0.65em",
                      fontWeight: "bold",
                      lineHeight: "1.2",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      wordBreak: "break-word"
                    }}>
                      {itm.name}
                    </div>
                    <div>
                      <div style={{ margin: "4px", fontSize: "0.65em" }}>
                        <CurrencySymbol/> <b>{itm.price}</b>
                      </div>
                    </div>
                  </div>}
      
                    )
                   
                  }
              </div></div>

}
